import React, { useState, useEffect } from "react";

import { Field, useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Grid,
  GridItem,
  Text,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";

import Group from "../../../ServicosAcolhimento/Visualizar/Group";

import { RadioButtonField } from "../../../../components/RadioButtonField";
import { CustomMultiSelectWField } from "../../../../components/MultiSelect";
import DoencaService from "../../../../../main/services/DoencaService";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import CustomFormSaude from "../../../../components/CustomFormSaude";

export const SaudeCadastrar = ({
  initialValues,
  valuesProps,
  idAnexo,
  scrollToField,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const { setCadastrarSaudeCrianca } = useAppContext();

  const [deficiencias, setDeficiencias] = useState({
    options: [],
    isLoading: false,
  });
  // const [doencas, setDoencas] = useState({
  //   options: [],
  //   isLoading: false,
  // });

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const handleGetDeficiencia = () => {
    setDeficiencias({ ...deficiencias, isLoading: true });

    DoencaService.listarDeficiencia().then((res) => {
      const tempOptions = res.data.map((deficiencia) => {
        return {
          idTipoDeficiencia: deficiencia.id,
          descricaoTipoDeficiencia: deficiencia.descricao,
        };
      });
      setDeficiencias({ options: tempOptions, isLoading: false });
    });
  };

  // const handleGetDoencas = () => {
  //   setDoencas({ ...doencas, isLoading: true });
  //   DoencaService.listarDoencaAtiva().then((res) => {
  //     const modifiedData = res.data.map((doenca) => {
  //       return {
  //         idDoenca: doenca.id,
  //         descricaoDoenca: doenca.descricao,
  //       };
  //     });
  //     setDoencas({ options: modifiedData, isLoading: false });
  //   });
  // };

  return (
    <Group
      title="Saúde"
      border={idAnexo === "11" ? "3px solid #4299E199" : ""}
      scrollToField={idAnexo === "11" ? scrollToField : null}
    >
      <Grid mt="15px" templateColumns="repeat(3, 1fr)" gap="25px" rowGap="20px">
        <GridItem position="relative" colSpan={{ base: 2, lg: 1 }} zIndex={"3"}>
          {setCadastrarSaudeCrianca(hasFormChanged(initialValues, valuesProps))}
          <Field name="possuiDeficiencia">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.possuiDeficiencia &&
                  form.touched.possuiDeficiencia
                }
                id="possuiDeficiencia"
                width="max-content"
                position="absolute"
                right="-90px"
                zIndex={"999"}
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) =>
                    setFieldValue("possuiDeficiencia", value)
                  }
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="possuiDeficiencia"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="possuiDeficiencia"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-14">
                  {form.errors.possuiDeficiencia}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
          <CustomMultiSelectWField
            fieldName="deficiencias"
            label="Possui Deficiência?*"
            placeholder="Selecione a Deficiência"
            getOptionLabel={(option) => option.descricaoTipoDeficiencia}
            getOptionValue={(option) => option.idTipoDeficiencia}
            isLoading={deficiencias.isLoading}
            options={deficiencias.options}
            values={values.deficiencias[0] || ""}
            onChange={(value) => {
              setFieldValue("deficiencias", value ? value : "");
            }}
            onFocus={
              deficiencias.options.length === 0 ? handleGetDeficiencia : null
            }
            visible={values.possuiDeficiencia === "S"}
          />
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />
        <GridItem position="relative" colSpan={{ base: 2, lg: 1 }} zIndex={"1"}>
          <Field name="possuiProblemasSaude">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.possuiProblemasSaude &&
                  form.touched.possuiProblemasSaude
                }
                id="possuiProblemasSaude"
                width="max-content"
                position="absolute"
                right="-90px"
                zIndex={"2"}
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) =>
                    setFieldValue("possuiProblemasSaude", value)
                  }
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="possuiProblemasSaude"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="possuiProblemasSaude"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                  <FormErrorMessage mt="-1" mr="-14">
                    {form.errors.possuiProblemasSaude}
                  </FormErrorMessage>
                </RadioGroup>
              </FormControl>
            )}
          </Field>
          <FormLabel
            color="#5F6377"
            whiteSpace={"nowrap"}
            height={"10px"}
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
          >
            Possui Algum Problema de Saúde?*
          </FormLabel>

          {/* <CustomMultiSelectWField
            fieldName="doencas"
            label="Possui algum problema de saúde?*"
            placeholder="Selecione a doença"
            getOptionLabel={(option) => option.descricaoDoenca}
            getOptionValue={(option) => option.idDoenca}
            isLoading={doencas.isLoading}
            options={doencas.options}
            values={values.doencas[0] || ""}
            onChange={(value) => {
              setFieldValue("doencas", value ? value : "");
            }}
            onFocus={doencas.options.length === 0 ? handleGetDoencas : null}
            visible={values.possuiProblemasSaude === "S"}
          /> */}
        </GridItem>

        {values.possuiProblemasSaude === "S" ? (
          <>
            <GridItem colSpan={{ base: 3, lg: 3 }}>
              <CustomFormSaude />
            </GridItem>
            <GridItem
              position="relative"
              mt={{
                base: "50px",
                md: "50px",
                lg: "0",
              }}
              colSpan={{ base: 2, lg: 1 }}
            >
              <Text
                color="#5F6377"
                fontWeight="500"
                height={{ lg: "20px" }}
                fontSize="14px"
                lineHeight="19.6px"
                htmlFor={"Usa Medicação Contínua?*"}
              >
                Usa Medicação Contínua?*
              </Text>
              <Field name="medicacaoContinua">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={
                      form.errors.medicacaoContinua &&
                      form.touched.medicacaoContinua
                    }
                    id="medicacaoContinua"
                    width="max-content"
                    position="absolute"
                    top="0"
                    right="-90px"
                  >
                    <RadioGroup
                      value={field.value}
                      onChange={(value) =>
                        setFieldValue("medicacaoContinua", value)
                      }
                    >
                      <Stack direction="row">
                        <RadioButtonField
                          fieldName="medicacaoContinua"
                          value="S"
                          label="Sim"
                        />
                        <RadioButtonField
                          fieldName="medicacaoContinua"
                          value="N"
                          label="Não"
                        />
                      </Stack>
                      <FormErrorMessage mt="-1" mr="-14">
                        {form.errors.medicacaoContinua}
                      </FormErrorMessage>
                    </RadioGroup>
                  </FormControl>
                )}
              </Field>
            </GridItem>
          </>
        ) : (
          ""
        )}

        <GridItem colSpan={{ lg: 2 }} />

        {/* {values.possuiProblemasSaude === "S" ? (
          <>
            <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
              <Text
                color="#5F6377"
                fontWeight="500"
                fontSize="14px"
                lineHeight="19.6px"
                htmlFor={"Faz tratamento de saúde?*"}>
                Faz tratamento de saúde?*
              </Text>

              <Field name="fazTratamento">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={
                      form.errors.fazTratamento && form.touched.fazTratamento
                    }
                    id="fazTratamento"
                    width="max-content"
                    position="absolute"
                    top="0"
                    right={{ base: "-129px", lg: "-331px" }}>
                    <RadioGroup
                      value={field.value}
                      onChange={(value) =>
                        setFieldValue("fazTratamento", value)
                      }>
                      <Stack
                        direction={{
                          base: "column",
                          md: "column",
                          lg: "row",
                        }}
                        gap={{ base: 0, md: 2 }}>
                        <RadioButtonField
                          fieldName="fazTratamento"
                          value="P"
                          label="Sim (Permanente)"
                        />
                        <RadioButtonField
                          fieldName="fazTratamento"
                          value="T"
                          label="Sim (Temporário)"
                        />
                        <RadioButtonField
                          fieldName="fazTratamento"
                          value="N"
                          label="Não"
                        />
                      </Stack>

                      <FormErrorMessage mt="-1" mr="-14">
                        {form.errors.fazTratamento}
                      </FormErrorMessage>
                    </RadioGroup>
                  </FormControl>
                )}
              </Field>
            </GridItem>
            <GridItem colSpan={{ lg: 2 }} />
            <GridItem
              position="relative"
              mt={{
                base: "50px",
                md: "50px",
                lg: "0",
              }}
              colSpan={{ base: 2, lg: 1 }}>
              <Text
                color="#5F6377"
                fontWeight="500"
                height={{ sm: "80px", md: "70px", lg: "20px" }}
                fontSize="14px"
                lineHeight="19.6px"
                htmlFor={"Usa medicação contínua?*"}>
                Usa medicação contínua?*
              </Text>
              <Field name="medicacaoContinua">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={
                      form.errors.medicacaoContinua &&
                      form.touched.medicacaoContinua
                    }
                    id="medicacaoContinua"
                    width="max-content"
                    position="absolute"
                    top="0"
                    right="-90px">
                    <RadioGroup
                      value={field.value}
                      onChange={(value) =>
                        setFieldValue("medicacaoContinua", value)
                      }>
                      <Stack direction="row">
                        <RadioButtonField
                          fieldName="medicacaoContinua"
                          value="S"
                          label="Sim"
                        />
                        <RadioButtonField
                          fieldName="medicacaoContinua"
                          value="N"
                          label="Não"
                        />
                      </Stack>
                      <FormErrorMessage mt="-1" mr="-14">
                        {form.errors.medicacaoContinua}
                      </FormErrorMessage>
                    </RadioGroup>
                  </FormControl>
                )}
              </Field>
            </GridItem>
          </>
        ) : (
          ""
        )} */}
      </Grid>
    </Group>
  );
};
